class EmptyRow {
    constructor() {
        this.position = '';
        this.width = '';
        this.height = '';
        this.number = '';
        this.type = '1';
        this.glass = '4-14-4';
        this.ventilation = '';
        this.commentsGlass = '';
        this.commentsVentilation = '';
        this.commentsWindow = '';
    }
}

export default EmptyRow


// WEBPACK FOOTER //
// ./src/data/EmptyRow.js